import React, { useRef } from "react"
import { Button, Dropdown, Typography } from "@mimber/ui-web"
import { EditOutlined, DeleteOutlined, MoreOutlined } from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { EditLineItemModal } from "@/components/modals/EditLineItemModal"
import { useDeleteInvoiceLineItemModal } from "@/components/modals/DeleteInvoiceLineItemModal"
import { Resource, Action } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems"
import type { InvoiceLineItemActionsDropdownProps } from "./InvoiceLineItemActionsDropdown.types"

const { Text } = Typography

export const InvoiceLineItemActionsDropdown: React.FunctionComponent<
  InvoiceLineItemActionsDropdownProps
> = ({
  invoiceUuid,
  lineItem,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const editOpenRef = useRef<(() => void) | null>(null)

  const { contextHolder, showDeleteInvoiceLineItemModal } =
    useDeleteInvoiceLineItemModal(invoiceUuid, onActionComplete)

  const menuItems: PermissionedMenuItem[] = [
    {
      key: "edit",
      label: "Edit",
      icon: <EditOutlined />,
      resource: Resource.INVOICE,
      action: Action.UPDATE,
      onClick: () => editOpenRef.current?.(),
    },
    {
      key: "delete",
      label: "Delete",
      icon: <DeleteOutlined />,
      danger: true,
      resource: Resource.INVOICE,
      action: Action.DELETE,
      onClick: () => showDeleteInvoiceLineItemModal(lineItem),
    },
  ]

  const { items: permissionedItems } = usePermissionedMenuItems({
    items: menuItems,
  })

  if (permissionedItems.length === 0) {
    return <Text type="secondary">—</Text>
  }

  return (
    <>
      {contextHolder}
      <EditLineItemModal
        invoiceUuid={invoiceUuid}
        lineItem={lineItem}
        onSuccess={onActionComplete}
        renderButton={(open) => {
          editOpenRef.current = open
          return <></>
        }}
      />
      <Dropdown menu={{ items: permissionedItems }} trigger={["click"]}>
        <Button size={size} type={type} icon={<MoreOutlined />}>
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
